/* Replay only. Shopify custom pixel owns events and the shared session context. */
(() => {
  if (window.__dearReplayInstalled) return;
  window.__dearReplayInstalled = true;
  if (!['dearplace.studio', 'www.dearplace.studio', 'shop.dearplace.studio'].includes(location.hostname)) return;
  if (/\/(account|checkouts?|orders)(\/|$)/.test(location.pathname)) return;

  const sessionKey='dp.posthog.session.v1';
  let requested=false;
  let contextTimer=null;
  function context(){
    try{
      const value=JSON.parse(localStorage.getItem(sessionKey)||'null'),now=Date.now();
      return value&&typeof value.clientId==='string'&&value.clientId&&/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value.sessionId)&&now-value.last<1800000&&now-value.start<86400000&&value.start<=now?value:null;
    }catch{return null;}
  }
  let recorder = null;
  let loading = false;
  let enabled = false;
  const status = value => { document.documentElement.dataset.dpReplayStatus = value; };
  // Explicit analytics consent, including on markets where the banner is optional.
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.currentVisitorConsent().analytics === 'yes'; }
    catch { return false; }
  };
  const cleanUrl = value => {
    try { const url = new URL(value, location.origin); return url.origin + url.pathname; }
    catch { return ''; }
  };
  const sync = () => {
    if (!allowed()) {
      if (recorder) {
        recorder.stopSessionRecording();
        recorder.opt_out_capturing();
      }
      enabled = false;
      status('waiting-consent');
      return;
    }
    if (recorder) {
      if (!enabled) {
        recorder.opt_in_capturing({ captureEventName: false });
        recorder.startSessionRecording();
        enabled = true;
      }
      status('enabled');
      return;
    }
    const shared=context();
    if(!shared){
      status('waiting-session');
      if(!requested&&window.Shopify?.analytics?.publish){
        requested=true;
        try{Promise.resolve(window.Shopify.analytics.publish('dp_posthog_session_request',{})).catch(()=>{requested=false;});}catch{requested=false;}
      }
      if(!contextTimer)contextTimer=setTimeout(()=>{contextTimer=null;sync();},250);
      return;
    }
    if (loading) return;
    loading = true;
    status('loading');
    const script = document.createElement('script');
    script.src = 'https://eu-assets.i.posthog.com/static/array.js';
    script.async = true;
    script.onerror = () => { loading = false; script.remove(); status('load-error'); };
    script.onload = () => {
      loading = false;
      // Consent can be revoked while the SDK is downloading.
      if (!allowed()) { status('waiting-consent'); return; }
      window.posthog.init('phc_AuzHtY2cnJ3BfrLYx7KapzFhET4ZQENm3UQmZdmVmhpu', {
        api_host: 'https://eu.i.posthog.com',
        ui_host: 'https://eu.posthog.com',
        persistence_name: 'dear_replay_unified_v1',
        bootstrap: {distinctID:shared.clientId,isIdentifiedID:false,sessionID:shared.sessionId},
        person_profiles: 'identified_only',
        capture_pageview: false,
        capture_pageleave: false,
        autocapture: false,
        rageclick: false,
        capture_dead_clicks: false,
        capture_performance: false,
        capture_exceptions: false,
        disable_surveys: true,
        disable_web_experiments: true,
        disable_product_tours: true,
        disable_conversations: true,
        enable_recording_console_log: false,
        disable_session_recording: true,
        opt_out_capturing_by_default: true,
        opt_out_persistence_by_default: true,
        save_campaign_params: false,
        save_referrer: false,
        session_recording: {
          maskAllInputs: true,
          // Personal map locations, generated images and cart personalization stay private.
          blockSelector: '.dp-location-map-card, .dp-preview-dialog, [data-cart-items], .dp-cart-table, iframe',
          maskTextSelector: '[contenteditable], .ph-mask',
          recordCrossOriginIframes: false,
          recordCanvas: false,
          recordBody: false,
          recordHeaders: false,
          maskCapturedNetworkRequestFn: request => cleanUrl(request.name) === cleanUrl(location.href)
            ? { ...request, name: cleanUrl(request.name), requestBody: undefined, responseBody: undefined, requestHeaders: undefined, responseHeaders: undefined }
            : null,
        },
        // This instance must never become a second analytics/event producer.
        before_send: event => {
          if (!allowed() || event.event !== '$snapshot') return null;
          // The SDK remains the session authority while recording is active.
          const sid=event.properties?.$session_id;
          if(sid){
            const start=parseInt(sid.replaceAll('-','').slice(0,12),16);
            if(Number.isFinite(start))try{localStorage.setItem(sessionKey,JSON.stringify({clientId:shared.clientId,sessionId:sid,start,last:Date.now()}));}catch{}
          }
          if (event.properties?.$current_url) event.properties.$current_url = cleanUrl(event.properties.$current_url);
          if (event.properties?.$referrer) event.properties.$referrer = cleanUrl(event.properties.$referrer);
          return event;
        },
        loaded: instance => { recorder = instance; sync(); },
      }, 'dearReplay');
    };
    document.head.appendChild(script);
  };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  status('waiting-consent');
  let attempts = 0;
  const timer = setInterval(() => {
    if (window.Shopify?.customerPrivacy) { clearInterval(timer); sync(); }
    else if (++attempts >= 120) { clearInterval(timer); status('privacy-api-unavailable'); }
  }, 500);
  sync();
})();
